import React from "react";
import { AlertTriangle, X } from "lucide-react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "../../../shared/ui";

interface CancelOfferModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

export const CancelOfferModal: React.FC<CancelOfferModalProps> = ({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  const handleClose = () => {
    if (isSubmitting) return;
    onClose();
  };

  return (
    <Modal
      open={open}
      onOpenChange={handleClose}
      overlayClassName="bg-black/60 backdrop-blur-sm"
      contentClassName="max-w-[440px] bg-white rounded-[20px] shadow-2xl border border-neutral-100"
    >
      <ModalHeader className="flex items-center justify-between px-6 pt-6 pb-2">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-danger-50 text-danger-600">
            <AlertTriangle size={20} />
          </div>
          <ModalTitle className="text-[18px] font-semibold text-neutral-900">
            Cancel offer
          </ModalTitle>
        </div>
        <button
          type="button"
          aria-label="Close modal"
          disabled={isSubmitting}
          onClick={handleClose}
          className="rounded-full p-1 text-neutral-500 hover:bg-neutral-100 hover:text-neutral-900 transition-colors disabled:opacity-50"
        >
          <X size={20} />
        </button>
      </ModalHeader>

      <ModalBody className="px-6 py-4">
        <p className="text-[14px] leading-relaxed text-neutral-600">
          Are you sure you want to cancel this offer? The customer will no longer be able to accept it, and the request status will revert to <strong>Under review</strong>.
        </p>
      </ModalBody>

      <ModalFooter className="flex items-center justify-end gap-3 px-6 pb-6 pt-2">
        <Button
          type="button"
          variant="outline"
          disabled={isSubmitting}
          onClick={handleClose}
        >
          No, keep offer
        </Button>
        <Button
          type="button"
          variant="danger"
          disabled={isSubmitting}
          onClick={onConfirm}
        >
          {isSubmitting ? "Cancelling..." : "Yes, cancel offer"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

